import axios from "axios";
import { baseUrl, buildQuery } from "../config/api-config";
const base = `${baseUrl}/auth`;

export function getUserAccounts(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/listallusers${q}`, {
    headers: {
      authorization: token,
    },
  });
}

export function deleteAccountById(token, id) {
  return axios.delete(`${baseUrl}/account_del/${id}`, {
    headers: {
      authorization: token,
    },
  });
}

export function insertAccount(token, data) {
  return axios.post(`${baseUrl}/insert_account`, data, {
    headers: {
      authorization: token,
    },
  });
}

export function updatedAccount(token, id, data) {
  return axios.patch(`${base}/updateuser/${id}`, data, {
    headers: {
      authorization: token,
    },
  });
}
export function getSubsidiary(token, query) {
  const q = buildQuery(query);
  return axios.get(`${baseUrl}/getSubsidiary${q}`, {
    headers: {
      authorization: token,
    },
  });
}
